import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const CampaignInstructionTemplates = lazy(() => import('../../container/campaign/CampaignInstructionTemplates'));
const Index = lazy(() => import('../../container/instruction/Integration'));

function IntegrationRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/campaign-templates`} component={CampaignInstructionTemplates} />
      <Route path={`${path}`} component={Index} />
    </Switch>
  );
}

export default IntegrationRoutes;
